const LOADING_TRAVEL_HOME_TITLE_PLACEHOLDER = 'American Express Travel';

export default LOADING_TRAVEL_HOME_TITLE_PLACEHOLDER;
